import { render, staticRenderFns } from "./NavSetting.vue?vue&type=template&id=fc5d3a88&scoped=true"
import script from "./NavSetting.vue?vue&type=script&lang=js"
export * from "./NavSetting.vue?vue&type=script&lang=js"
import style0 from "./NavSetting.vue?vue&type=style&index=0&id=fc5d3a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5d3a88",
  null
  
)

export default component.exports